import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import { sxText } from "./sxProps";

interface DefaultTextProps extends TypographyProps {
    size?: "xs" | "small" | "base" | "medium" | "large" | "x-large" | "xx-large" | "xxx-large";
    bold?: boolean;
    color?: string;
    sx?: any;
    lineHeight?: string
}

const DefaultText: React.FC<DefaultTextProps> = ({ children, size = "base", bold, color, sx, lineHeight, ...props }) => {
    const fontSize = `var(--font-size-${size})`;

    return (
        <Typography
            sx={{
                ...sxText,
                color: color || "var(--primary-blue)",
                fontSize: fontSize,
                fontWeight: bold ? "bold" : "normal",
                lineHeight: lineHeight || '30px',
                whiteSpace: 'pre-line',
                ...sx
            }}
            {...props}
        >
            {children}
        </Typography>
    );
};

export default DefaultText;
